/** Linkers for an uploaded ontology: fuzzy label search over its N3 store's index. */
import type {
  EntityCandidate,
  EntityLinker,
  LinkOptions,
  PropertyCandidate,
  RelationLinker,
} from "./types.ts";
import type { LabelIndex } from "../rdf/ontology.ts";

export class LocalEntityLinker implements EntityLinker {
  readonly sourceId: string;
  private readonly index: LabelIndex;
  constructor(sourceId: string, index: LabelIndex) {
    this.sourceId = sourceId;
    this.index = index;
  }
  async link(mention: string, opts?: LinkOptions): Promise<EntityCandidate[]> {
    return this.index.search(mention, opts?.limit ?? 7).map(({ entry, score }) => {
      const c: EntityCandidate = { iri: entry.iri, label: entry.label, score, sourceId: this.sourceId };
      if (entry.description) c.description = entry.description;
      return c;
    });
  }
}

export class LocalRelationLinker implements RelationLinker {
  readonly sourceId: string;
  private readonly index: LabelIndex;
  constructor(sourceId: string, index: LabelIndex) {
    this.sourceId = sourceId;
    this.index = index;
  }
  async link(phrase: string, opts?: LinkOptions): Promise<PropertyCandidate[]> {
    return this.index.search(phrase, opts?.limit ?? 7).map(({ entry, score }) => {
      // For a plain ontology the predicate IRI *is* the property IRI (no wdt:).
      const c: PropertyCandidate = {
        iri: entry.iri,
        entityIri: entry.iri,
        label: entry.label,
        score,
        sourceId: this.sourceId,
        origin: "search",
      };
      if (entry.description) c.description = entry.description;
      return c;
    });
  }
}
